import { render, staticRenderFns } from "./RateCardCreate.vue?vue&type=template&id=5a738096&scoped=true&"
import script from "./RateCardCreate.vue?vue&type=script&lang=ts&"
export * from "./RateCardCreate.vue?vue&type=script&lang=ts&"
import style0 from "./RateCardCreate.vue?vue&type=style&index=0&id=5a738096&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a738096",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCardText,VCol,VRow,VSkeletonLoader})
